<template lang="pug">
i.rouble Р
</template>

<script>
  export default {}
</script>

<style lang="stylus" scoped>
.rouble
  font-weight: 700
  font-family: "Open Sans", sans-serif
  position: relative
  font-style: normal
  display: inline-block
  text-transform: uppercase
  line-height: 100%
  white-space: nowrap

  &:before
    line-height: 100%
    font-size: .6em
    position: absolute
    left: -.05em
    content: '\2014'
    width: .55em
    top: .55em
</style>


// WEBPACK FOOTER //
// Rouble.vue?695c0d1a